import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import TodaysPick from '../Todays/TodaysPick';
import Banner from '../Banner/Banner';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import FeaturedProduct from '../Todays/FeaturedProduct';
import Swal from 'sweetalert2';
import { Col, Row } from 'react-bootstrap';
const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};
const Checkout = () => {
  const [timeLeft, setTimeLeft] = useState(9 * 60 + 34);
  const navigate = useNavigate()
  const [cartItems, setCartItems] = useState([]);
  const [shippingOption, setShippingOption] = useState('free');
  const [voucherCode, setVoucherCode] = useState('');
  const [coupons, setCoupons] = useState([]);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState('');
  const [agree, setAgree] = useState(false);



  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const res = await axios.get("https://vantara.datacubeglobal.com/api/get-coupons");
        if (res.data.status === "success") {
          setCoupons(res.data.coupons);
        }
      } catch (err) {
        console.error("Error fetching coupons:", err);
      }
    };
    fetchCoupons();
  }, []);


  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // const updateQuantity = (id, change) => {
  //   setCartItems(cartItems.map(item => {
  //     if (item.id === id) {
  //       const newQuantity = Math.max(0, item.quantity + change);
  //       return {
  //         ...item,
  //         quantity: newQuantity,
  //         total: newQuantity * item.price
  //       };
  //     }
  //     return item;
  //   }));
  // };

  const updateQuantity = async (id, change) => {
    const token = getAuthToken();
    if (!token) {

      return;
    }


    const item = cartItems.find(ci => ci.id === id);
    if (!item) return;

    const newQuantity = Math.max(1, item.quantity + change);


    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/cart/update-count",
        {
          product_id: item.product_id,
          count: newQuantity,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === "success") {

        setCartItems(cartItems.map(ci =>
          ci.id === id
            ? { ...ci, quantity: newQuantity, total: newQuantity * ci.price }
            : ci
        ));
      } else {
        console.error("Update count failed:", res.data);
      }
    } catch (err) {
      console.error("Error updating count:", err);
    }
  };




  const fetchCart = async () => {
    const token = getAuthToken();

    if (!token) {
      console.warn("No auth token found, user may need to login.");
      setCartItems([]);
      return;
    }

    try {
      const res = await axios.get("https://vantara.datacubeglobal.com/api/cart", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status === "success") {
        const items = res.data.data.map((item) => {
          const imagePath = item.product?.primary_image?.image_path;
          const imageUrl = imagePath
            ? `https://vantara.datacubeglobal.com/storage/${imagePath}`
            : "https://via.placeholder.com/70"; // fallback image

          return {
            id: item.cart_id,
            product_id: item.product.encrypted_product_id,
            name: item.product.product_name,
            price: parseFloat(item.product.special_price),
            quantity: item.quantity,
            total: parseFloat(item.product.special_price) * item.quantity,
            image: imageUrl,

          };
        });

        setCartItems(items);
      }
    } catch (err) {
      console.error("Error fetching cart:", err);
    }
  };

  const removeItem = async (product_id) => {

    const token = getAuthToken();
    if (!token) return;

    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/cart/remove-item",
        { product_id: product_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === "success") {

        fetchCart();
      }
    } catch (err) {
      console.error("Error removing item:", err);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);

  const calculateSubtotal = () => {
    return cartItems.reduce((sum, item) => sum + item.total, 0);
  };

  // const calculateDiscounts = () => {
  //   return 80.00; // Fixed discount as shown in image
  // };

  // const calculateShipping = () => {
  //   switch (shippingOption) {
  //     case 'free': return 0;
  //     case 'local': return 35;
  //     case 'flat': return 35;
  //     default: return 0;
  //   }
  // };

  const calculateTotal = () => {
    return calculateSubtotal() - discountAmount;
  };

  // const handleApplyCode = () => {
  //   const coupon = coupons.find(
  //     (c) => c.code.toLowerCase() === voucherCode.toLowerCase()
  //   );

  //   if (!coupon) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Invalid Coupon!",
  //       text: "Please check your code and try again.",
  //       confirmButtonColor: "#000",
  //     });
  //     setDiscountAmount(0);
  //     setAppliedCoupon(null);
  //     return;
  //   }

  //   const subtotal = calculateSubtotal();
  //   if (subtotal < parseFloat(coupon.min_order_amount)) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Minimum Order Not Met",
  //       text: `Minimum order amount is ₹${coupon.min_order_amount}`,
  //       confirmButtonColor: "#000",
  //     });
  //     return;
  //   }

  //   let discount = 0;
  //   if (coupon.type === "fixed") {
  //     discount = parseFloat(coupon.value);
  //   } else if (coupon.type === "percentage") {
  //     discount = (subtotal * parseFloat(coupon.value)) / 100;
  //   }

  //   setDiscountAmount(discount);
  //   setAppliedCoupon(coupon);

  //   Swal.fire({
  //     icon: "success",
  //     title: "Coupon Applied!",
  //     text: `Coupon "${coupon.code}" applied successfully.`,
  //     confirmButtonColor: "#000",
  //   });
  // };

  useEffect(() => {
    const savedCoupon = sessionStorage.getItem("appliedCoupon");
    const savedDiscount = sessionStorage.getItem("discountAmount");
    const savedVoucher = sessionStorage.getItem("voucherCode");

    if (savedCoupon) setAppliedCoupon(JSON.parse(savedCoupon));
    if (savedDiscount) setDiscountAmount(parseFloat(savedDiscount));
    if (savedVoucher) setVoucherCode(savedVoucher);
  }, []);

  // const handleApplyCode = async () => {
  //   if (!voucherCode) {
  //     // Swal.fire({
  //     //   icon: "warning",
  //     //   title: "Enter Coupon",
  //     //   text: "Please enter a coupon code.",
  //     //   confirmButtonColor: "#000",
  //     // });
  //     return;
  //   }

  //   const subtotal = calculateSubtotal();
  //   const token = getAuthToken();

  //   try {
  //     const response = await axios.post(
  //       "https://vantara.datacubeglobal.com/api/coupon/validate",
  //       {
  //         coupon_code: voucherCode,
  //         total_amount: subtotal,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     // Ensure we get the actual response
  //     const data = response?.data;

  //     // Check for error
  //     if (!data || data.status === "error") {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Coupon Not Applicable",
  //         text: data?.message || "Invalid coupon",
  //         confirmButtonColor: "#000",
  //       });
  //       setDiscountAmount(0);
  //       setAppliedCoupon(null);
  //         sessionStorage.removeItem("appliedCoupon");
  //         sessionStorage.removeItem("discountAmount");
  //         sessionStorage.removeItem("voucherCode");
  //       return;
  //     }

  //     // Coupon is valid
  //     const coupon = coupons.find(
  //       (c) => c.code.toLowerCase() === voucherCode.toLowerCase()
  //     ) || data.coupon; // fallback to API coupon

  //     let discount = 0;
  //     if (coupon.type === "fixed") {
  //       discount = parseFloat(coupon.value);
  //     } else if (coupon.type === "percentage") {
  //       discount = (subtotal * parseFloat(coupon.value)) / 100;
  //     }

  //     setDiscountAmount(discount);
  //     setAppliedCoupon(coupon);

  //     Swal.fire({
  //       icon: "success",
  //       title: "Coupon Applied!",
  //       text: `Coupon "${coupon.code}" applied successfully.`,
  //       confirmButtonColor: "#000",
  //     });

  //   } catch (error) {
  //     console.error("Error validating coupon:", error);

  //     // Try to show API error message if available
  //     const apiMessage = error?.response?.data?.message;

  //     Swal.fire({
  //       icon: "error",
  //       title: "Something went wrong",
  //       text: apiMessage || "Could not validate coupon. Please try again.",
  //       confirmButtonColor: "#000",
  //     });
  //   }
  // };



  const handleApplyCode = async () => {
    setCouponError('');
    // if (!voucherCode) {
    //   setCouponError('Please enter a coupon code.');
    //   return;
    // }

    const subtotal = calculateSubtotal();
    const token = getAuthToken();

    try {
      const response = await axios.post(
        "https://vantara.datacubeglobal.com/api/coupon/validate",
        {
          coupon_code: voucherCode,
          total_amount: subtotal,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response?.data;

      if (!data || data.status === "error") {
        setCouponError(data?.message || "Invalid or expired coupon.");
        setDiscountAmount(0);
        setAppliedCoupon(null);
        setVoucherCode('');
        sessionStorage.removeItem("appliedCoupon");
        sessionStorage.removeItem("discountAmount");
        sessionStorage.removeItem("voucherCode");
        return;
      }


      const coupon = coupons.find(
        (c) => c.code.toLowerCase() === voucherCode.toLowerCase()
      ) || data.coupon;

      let discount = 0;
      if (coupon.type === "fixed") {
        discount = parseFloat(coupon.value);
      } else if (coupon.type === "percentage") {
        discount = (subtotal * parseFloat(coupon.value)) / 100;
      }

      setDiscountAmount(discount);
      setAppliedCoupon(coupon);
      setCouponError('');

      setVoucherCode('');
      sessionStorage.setItem("appliedCoupon", JSON.stringify(coupon));
      sessionStorage.setItem("discountAmount", discount);
      sessionStorage.setItem("voucherCode", voucherCode);
    } catch (error) {
      console.error("Error validating coupon:", error);
      const apiMessage = error?.response?.data?.message;
      setCouponError(apiMessage || "Something went wrong. Please try again.");
    }
  };

  useEffect(() => {

    if (cartItems.length === 0) {
      setAppliedCoupon(null);
      setDiscountAmount(0);
      setVoucherCode('');


      sessionStorage.removeItem("appliedCoupon");
      sessionStorage.removeItem("discountAmount");
      sessionStorage.removeItem("voucherCode");
    }
  }, [cartItems]);


  return (
    <>  <Banner title="Cart" />
      <div className="container my-5" >

        <div className="row">

          <div className="col-lg-8">
            <div className="p-4">
              <h5 className="mb-4">Products</h5>

              <div className="d-lg-none">
                {cartItems.map((item) => (
                  <div key={item.id} className="border-bottom pb-3 mb-3">

                    <div className="d-flex align-items-start mb-2">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="rounded"
                        style={{ width: '80px', height: '90px', objectFit: 'cover' }}
                      />
                      <div className="flex-grow-1 ms-3">
                        <h6 className="mb-3">{item.name}</h6>
                        <div className="d-flex justify-content-between mb-2">
                          <span className="small">Price</span>
                          <span className="fw-bold">{item.price.toFixed(2)}</span>
                        </div>
                        <hr className="my-2" style={{ borderColor: '#e9ecef' }} />
                        <div className="d-flex justify-content-between mb-2">
                          <span className="small">Quantity</span>
                          {/* <div className="d-flex align-items-center border rounded-pill px-1"
                            style={{ width: '100px' }}>
                            <button
                              className="btn btn-sm border-0"
                              style={{ borderRadius: '50%', fontWeight: 'bold' }}
                              onClick={() => updateQuantity(item.id, -1)}
                              disabled={item.quantity <= 1}
                            >
                              −
                            </button>
                            <span className="mx-2">{item.quantity}</span>
                            <button
                              className="btn btn-sm border-0"
                              style={{ borderRadius: '50%', fontWeight: 'bold' }}
                              onClick={() => updateQuantity(item.id, 1)}
                            >
                              +
                            </button>
                          </div> */}
                          <div className="d-flex align-items-center justify-content-between border rounded-pill px-2"
                            style={{ width: '100px' }}>
                            <button
                              className="btn btn-sm border-0 d-flex align-items-center justify-content-center"
                              style={{
                                borderRadius: '50%',
                                fontWeight: 'bold',
                                width: '24px',
                                height: '24px',
                                padding: 0
                              }}
                              onClick={() => updateQuantity(item.id, -1)}
                              disabled={item.quantity <= 1}
                            >
                              −
                            </button>
                            <span className="fw-bold">{item.quantity}</span>
                            <button
                              className="btn btn-sm border-0 d-flex align-items-center justify-content-center"
                              style={{
                                borderRadius: '50%',
                                fontWeight: 'bold',
                                width: '24px',
                                height: '24px',
                                padding: 0
                              }}
                              onClick={() => updateQuantity(item.id, 1)}
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <hr className="my-2" style={{ borderColor: '#e9ecef' }} />
                        <div className="d-flex justify-content-between mb-3">
                          <span className="small">Total</span>
                          <span className="fw-bold">{item.total.toFixed(2)}</span>
                        </div>
                        <hr className="my-2" style={{ borderColor: '#e9ecef' }} />
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span
                            className="text-danger small"
                            style={{ fontWeight: '500', cursor: 'pointer' }}
                            onClick={() => removeItem(item.product_id)}
                          >
                            Remove
                          </span>
                          <span
                            className="d-inline-flex align-items-center justify-content-center rounded-circle border border-danger text-danger"
                            style={{
                              width: '24px',
                              height: '24px',
                              fontSize: '0.9rem',
                              cursor: 'pointer',
                              lineHeight: '1',
                              backgroundColor: 'transparent',
                              transition: 'color 0.2s ease',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.color = '#FFFFFF';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.color = '';
                            }}
                            onClick={() => removeItem(item.product_id)}
                            role="button"
                            aria-label="Remove item"
                          >
                            ×
                          </span>

                        </div>

                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {/* Desktop View - Table Layout */}
              <div className="d-none d-lg-block">
                <div className="table-responsive">
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">Product</th>
                        <th scope="col">Price</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Total </th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItems.map(item => (
                        <tr key={item.id} className="align-middle">
                          <td>
                            <img
                              src={item.image}
                              onClick={() => navigate(`/productDetails/${item.product_id}`)}
                              alt='Image'
                              className="img-fluid"
                              style={{ width: '200px', height: '100px', objectFit: 'cover' }}
                            />
                          </td>
                          <td>
                            <div className="">{item.name}</div>

                          </td>
                          <td className="">{item.price.toFixed(2)}</td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center border rounded-pill mx-auto"
                              style={{ width: "110px" }}>
                              <button
                                className="btn btn-sm border-0 flex-fill"
                                style={{ borderRadius: "50%", fontWeight: "bold" }}
                                onClick={() => updateQuantity(item.id, -1)}
                                disabled={item.quantity <= 1}
                              >
                                −
                              </button>
                              <span className="flex-fill text-center">{item.quantity}</span>
                              <button
                                className="btn btn-sm border-0 flex-fill"
                                style={{ borderRadius: "50%", fontWeight: "bold" }}
                                onClick={() => updateQuantity(item.id, 1)}
                              >
                                +
                              </button>
                            </div>
                          </td>
                          <td className="fw-bold">{item.total.toFixed(2)}</td>
                          <td className="">
                            <span
                              className="d-inline-flex align-items-center justify-content-center rounded-circle border border-danger text-danger"
                              style={{
                                width: '24px',
                                height: '24px',
                                fontSize: '0.9rem',
                                cursor: 'pointer',
                                lineHeight: '1',
                                backgroundColor: 'transparent',
                                transition: 'color 0.2s ease',
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.color = '#FFFFFF';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.color = '';
                              }}
                              onClick={() => removeItem(item.product_id)}
                              role="button"
                              aria-label="Remove item"
                            >
                              ×
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="mt-4 d-flex gap-2">
                <input
                  type="text"
                  className="form-control flex-grow-1"
                  placeholder="Add voucher discount"
                  value={voucherCode}
                  onChange={(e) => setVoucherCode(e.target.value)}
                  style={{
                    border: '1px solid #ced4da',
                    borderRadius: '0.25rem',
                    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.075)',
                    outline: 'none'
                  }}
                />
                <button
                  className="btn  text-nowrap"
                  onClick={handleApplyCode}
                  style={{ backgroundColor: '#1C3F1D', color: 'white', fontWeight: '500', padding: '0.5rem 1rem', borderRadius: '0.25rem' }}
                >
                  Apply Code
                </button>
              </div>

              {couponError && (
                <div className="text-danger mt-1 font-bold" style={{ fontWeight: 500 }}>
                  {couponError}
                </div>
              )}
              {/* <div className="mb-3"></div> */}
              <div className="mb-3">
                <div
                  className="d-flex gap-3 overflow-auto pb-2"
                  style={{
                    scrollSnapType: "x mandatory",
                    WebkitOverflowScrolling: "touch",
                  }}
                >
                  {coupons.length > 0 ? (
                    coupons.map((coupon) => (
                      <div
                        key={coupon.id}
                        className="bg-light p-3 rounded border coupon-card flex-shrink-0"
                        style={{
                          width: "220px",
                          scrollSnapAlign: "start",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <div className="small text-uppercase text-muted">Discount Code</div>
                            <div className="h6 mb-1">{coupon.code}</div>
                            <div className="small text-muted">{coupon.coupon_name}</div>
                            <div className="text-success small mt-1">
                              {coupon.type === "fixed"
                                ? `Flat ₹${coupon.value} off`
                                : `${coupon.value}% off`}
                            </div>
                          </div>
                          <button
                            className="btn btn-outline-dark btn-sm px-3 py-1"
                            onClick={(e) => {
                              e.stopPropagation();
                              setVoucherCode(coupon.code);
                              handleApplyCode();
                            }}
                          >
                            Use
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">No coupons available right now.</p>
                  )}
                </div>
              </div>




            </div>
          </div>

          {/* Order Summary */}
          <div className="col-lg-4">
            <div
              className="rounded shadow-sm p-4"
              style={{ backgroundColor: '#f8f9fa' }}
            >
              <h5 className="mb-4">Order Summary</h5>

              <div className="d-flex justify-content-between mb-3">
                <span>Subtotal ({cartItems.reduce((sum, item) => sum + item.quantity, 0)} items)</span>
                <span>{calculateSubtotal().toFixed(2)}</span>
              </div>

              <div className="d-flex justify-content-between mb-3 text-danger">
                {/* <span>Discounts</span>
                <span>-{calculateDiscounts().toFixed(2)}</span> */}
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Shipping</label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="shipping"
                    id="freeShipping"
                    value="free"
                    checked={shippingOption === 'free'}
                    onChange={() => setShippingOption('free')}
                  />
                  <label className="form-check-label d-flex justify-content-between" htmlFor="freeShipping">
                    <span>Free Shipping</span>
                    <span>0.00</span>
                  </label>
                </div>

              </div>

              <hr className="my-3" />
              {appliedCoupon && (
                <div className="d-flex justify-content-between align-items-center mb-3 text-success">
                  <span>
                    Coupon: {appliedCoupon.coupon_code || appliedCoupon.code}
                  </span>
                  <div className="d-flex align-items-center gap-2">
                    <span>-{discountAmount.toFixed(2)}</span>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      style={{ padding: '0.15rem 0.5rem' }}
                      onClick={() => {
                        setAppliedCoupon(null);
                        setDiscountAmount(0);
                        setVoucherCode('');
                        sessionStorage.removeItem("appliedCoupon");
                        sessionStorage.removeItem("discountAmount");
                        sessionStorage.removeItem("voucherCode");
                      }}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-between mb-3">
                <span className="fw-bold">Total</span>
                <span className="fw-bold fs-5">{calculateTotal().toFixed(2)}</span>
              </div>

             <div className="d-none d-lg-block">
  <div className="form-check mb-3">
    <input
      className="form-check-input"
      type="checkbox"
      id="termsCheck"
      checked={agree}
      onChange={() => setAgree(!agree)}
    />
    <label className="form-check-label small" htmlFor="termsCheck">
      I agree with the <a href="#" className="text-decoration-none">Terms And Conditions</a>
    </label>
  </div>

  <button 
    className="btn w-100 py-2 fw-bold rounded-pill mb-2" 
    disabled={!agree} 
    style={{ backgroundColor: '#7B0045', color: 'white' }} 
    onClick={() =>
      navigate("/proceedcheckout", {
        state: {
          appliedCoupon,
          discountAmount,
          voucherCode,
          totalAmount: calculateTotal(),
          subtotal: calculateSubtotal(),
        },
      })
    }
  >
    Process To Checkout
  </button>
</div>
              <a href="#" className="text-center d-block text-muted small">Or continue shopping</a>
            </div>
          </div>
          <FeaturedProduct />
          <TodaysPick />
          <hr />
        </div>
      </div>
<div className="d-lg-none fixed-bottom bg-white border-top shadow-lg">
    <div className="container">
      {/* Scrollable mini-summary (max height to avoid covering too much) */}
      <div
        className="py-3"
        style={{
          maxHeight: '200px',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          fontSize: '0.9rem',
        }}
      >
        <div className="d-flex justify-content-between mb-1">
          <span className="text-muted">Subtotal ({cartItems.reduce((sum, item) => sum + item.quantity, 0)} items)</span>
          <span>{calculateSubtotal().toFixed(2)}</span>
        </div>

        <div className="d-flex justify-content-between mb-1">
          <span className="text-muted">Shipping</span>
          <span>0.00</span>
        </div>

        {appliedCoupon && (
          <div className="d-flex justify-content-between mb-1 text-success">
            <span className="text-success">Discount</span>
            <span>-{discountAmount.toFixed(2)}</span>
          </div>
        )}

        <hr className="my-2" />

        <div className="d-flex justify-content-between mb-2">
          <span className="fw-bold">Total</span>
          <span className="fw-bold fs-5" style={{ color: '#7B0045' }}>
            {calculateTotal().toFixed(2)}
          </span>
        </div>
      </div>

      {/* Terms & Button - always visible (not scrollable) */}
      <div className="pt-2 border-top">
        <div className="form-check mb-2">
          <input
            className="form-check-input"
            type="checkbox"
            id="termsCheckMobile"
            checked={agree}
            onChange={() => setAgree(!agree)}
            style={{ marginTop: '0.15rem' }}
          />
          <label className="form-check-label small" htmlFor="termsCheckMobile">
            I agree with the{' '}
            <a href="#" className="text-decoration-none">Terms And Conditions</a>
          </label>
        </div>
        <button
          className="btn w-100 py-2 fw-bold rounded-pill mb-4"
          disabled={!agree}
          style={{ backgroundColor: '#7B0045', color: 'white' }}
          onClick={() =>
            navigate("/proceedcheckout", {
              state: {
                appliedCoupon,
                discountAmount,
                voucherCode,
                totalAmount: calculateTotal(),
                subtotal: calculateSubtotal(),
              },
            })
          }
        >
          Proceed To Checkout
        </button>
      </div>
    </div>
  </div>
    </>
  );
};

export default Checkout;